import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation]);

export default class CollectionBannerCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * collections banner carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.slides = this.sliderElement.querySelector('.js-slide');
        this.init();
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 1.5,
            spaceBetween: 8,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev,
                lockClass: 'swiper-button-lock--visible'
            },
            breakpoints: {
                768: {
                    spaceBetween: 14
                },
                1024: {
                    slidesOffsetAfter: 55,
                    slidesOffsetBefore: 55
                }
            }
        });
    }
}
